import React, { useEffect, useState } from 'react';
// import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import downArrowIcon from '../../../../../assets/icons/left-ar.svg';
import appLS from '../../../../../constants/local-storage';
import getProducts from '../../../../../redux/actions/products/getProducts';
import getUser from '../../../../../redux/actions/user/getUser';
import apiService from '../../../../../services/apiService';

export default function CompanyDropdown(params) {

  const companies = useSelector(state => state.companies);
  const products = useSelector(state => state.products);
  const user = JSON.parse(localStorage.getItem(appLS.user));
  const dispatch = useDispatch();

  const getCompanyName = () => {
    if (companies && Object.entries(companies.data).length > 0) {
      const company = companies.data.filter(comp => comp.Key === localStorage.getItem(appLS.companyKey))
      return company.length > 0 ? company[0].Name : 'Select a company'
    }
  }

  const [companyName, setCompanyName] = useState(getCompanyName())

  // const { i18n, t: trans } = useTranslation();

  const onCompanySelect = (key) => {
    localStorage.setItem(appLS.companyKey, key);
    apiService.setCompanyKey();
    dispatch(getUser());
    dispatch(getProducts());
    setCompanyName(getCompanyName());
  }

  useEffect(() => {
    if (companies && Object.entries(companies.data).length > 0) {
      const company = companies.data.filter(comp => comp.Key === localStorage.getItem(appLS.companyKey))
      setCompanyName(company.length > 0 ? company[0].Name : 'Select a company');
    }
  }, [products, companies])

  return <>{
    user &&
    companyName ? <div className='company-dropdown'>
      <label><span>Company ({companyName})</span>
        <img src={downArrowIcon} alt="DropDownArrow" />
        <section>
          {
            companies &&
              companies.pending ?
              <p>please wait!</p> :
              <ul>
                {
                  !companies.error && Object.entries(companies.data).length > 0 && companies.data.map(comp =>
                    <li key={comp.Key} onClick={() => { onCompanySelect(comp.Key) }}>{comp.Name}</li>)
                }
              </ul>
          }
        </section>
      </label>
    </div>
      :
      null
  }
  </>
}